(function () {
  // Today's Deals scheduling. Liquid sets data-td-start / data-td-end (epoch seconds, store
  // timezone already applied) and an initial data-td-live on cards, deal blocks and the campaign
  // hero. Shopify serves cached pages for a while, so this re-checks the visitor's clock on load,
  // every 30 seconds, and when the tab comes back into view. The theme editor never hides anything
  // (scheduled items carry a status tag there instead).
  if (window.__tdScheduleReady) return;
  window.__tdScheduleReady = true;

  // Liquid only prints data-td-editor inside the theme editor, so it doubles as a design-mode signal.
  var inEditor = !!(window.Shopify && window.Shopify.designMode) || !!document.querySelector('[data-td-editor]');

  // Oct 19 promos: date preview override. Add ?deals_at=2026-10-20 (or deals_at=2026-10-20T08:30) to any
  // page URL and every scheduled card, block, hero, hero tile and homepage tile is shown as it will be at that
  // moment, instead of now. The value is read as store time (America/New_York, the same timezone Liquid uses
  // for the schedule dropdowns); a date without a time means 12:00 PM (noon) that day, so it lands well inside
  // the day. If the browser cannot do timezone maths it falls back to the visitor's own clock timezone.
  // Liquid never removes off-schedule items (they stay in the page with data-td-live="false"), so this can
  // reveal future content. It only acts when the parameter is present, never in the theme editor, and the
  // time stays fixed while the page is open (every 30-second re-check uses the same moment).
  var STORE_TZ = 'America/New_York';
  function storeEpoch(y, mo, d, h, mi) {
    var guess = Date.UTC(y, mo - 1, d, h, mi);
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: STORE_TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
      }).formatToParts(new Date(guess));
      var p = {};
      parts.forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      var asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute);
      var offset = asUtc - guess;
      var t = guess - offset;
      // Second pass so a date near a daylight-saving change uses the offset of the target moment itself.
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: STORE_TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
      }).formatToParts(new Date(t));
      p = {};
      parts.forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute);
      return (guess - (asUtc - t)) / 1000;
    } catch (e) {
      return new Date(y, mo - 1, d, h, mi).getTime() / 1000;
    }
  }
  function previewNow() {
    if (inEditor) return 0;
    var raw = '';
    try { raw = new URLSearchParams(window.location.search).get('deals_at') || ''; } catch (e) { return 0; }
    var m = raw.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2}))?$/);
    if (!m) return 0;
    var h = m[4] !== undefined ? parseInt(m[4], 10) : 12;
    var mi = m[5] !== undefined ? parseInt(m[5], 10) : 0;
    var t = storeEpoch(parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10), h, mi);
    return isFinite(t) ? t : 0;
  }
  var previewAt = previewNow();
  if (previewAt) {
    window.__tdPreviewAt = previewAt;
    if (window.console && console.info) console.info('Today\'s Deals: previewing the schedule at ' + new Date(previewAt * 1000).toString() + ' (deals_at in the URL).');
  }

  function isLive(el) {
    return el.getAttribute('data-td-live') !== 'false';
  }

  // Without the filter pills on the page nobody else collapses a block whose cards are all off-schedule.
  function refreshBlocks() {
    if (document.querySelector('[data-td-filter]')) return;
    document.querySelectorAll('[data-td-promo-grid]').forEach(function (grid) {
      var cards = grid.querySelectorAll('.td-promo-card');
      var any = false;
      cards.forEach(function (c) { if (isLive(c)) any = true; });
      grid.classList.toggle('is-empty', cards.length > 0 && !any);
    });
  }

  // Oct 19 promos (fix round 1): a wide card left alone at the end of a deal block (for example the fifth wide
  // card of "This month's biggest deals", or the only card a filter pill leaves) gets td-card--fill, which makes
  // it take the whole row like a "Full row" card (assets/todays-deals.css) instead of sitting next to an empty
  // half. It follows the schedule and the filter pills: deals-filter.js calls it again after every filter change.
  // Rows are counted with the block's desktop column count; on tablets and phones a wide card already fills its row.
  function fillRows() {
    if (inEditor) return;
    document.querySelectorAll('.td-grid--mixed').forEach(function (grid) {
      var cols = parseInt(grid.style.getPropertyValue('--td-cols-desktop'), 10) || 4;
      var lead = grid.classList.contains('td-grid--lead');
      var pos = 0;
      var row = [];
      var cards = Array.prototype.slice.call(grid.children).filter(function (c) { return c.classList.contains('td-card'); });
      cards.forEach(function (card) {
        if (window.getComputedStyle(card).display === 'none') return;
        var wide = card.classList.contains('td-card--wide');
        var full = card.classList.contains('td-card--full') || (lead && wide && card === grid.firstElementChild);
        var span = full ? cols : (wide ? Math.min(2, cols) : 1);
        if (pos + span > cols) { pos = 0; row = []; }
        row.push({ card: card, wide: wide && !full });
        pos += span;
        if (pos >= cols) { pos = 0; row = []; }
      });
      var lone = row.length === 1 && row[0].wide ? row[0].card : null;
      cards.forEach(function (card) { card.classList.toggle('td-card--fill', card === lone); });
    });
  }
  window.tdFillRows = fillRows;

  function evaluate() {
    if (inEditor) return;
    var now = previewAt || Date.now() / 1000; // Oct 19 promos: deals_at preview override (see above)
    var changed = false;
    document.querySelectorAll('[data-td-start], [data-td-end]').forEach(function (el) {
      var start = parseFloat(el.getAttribute('data-td-start') || '0') || 0;
      var end = parseFloat(el.getAttribute('data-td-end') || '0') || 0;
      var live = (!start || now >= start) && (!end || now <= end);
      if (live !== isLive(el)) {
        el.setAttribute('data-td-live', live ? 'true' : 'false');
        changed = true;
      }
    });
    refreshBlocks();
    if (changed) document.dispatchEvent(new CustomEvent('td:schedule'));
    fillRows(); // Oct 19 promos (fix round 1), see above
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
  setInterval(evaluate, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) evaluate(); });
  document.addEventListener('shopify:section:load', evaluate);
})();
